import React from 'react';
import CustomerServicesBanner from './CustomerServicesBanner/CustomerServicesBanner';
// import CustomerServicesSection from './CustomerServicesSection/CustomerServicesSection';
import ContactUsForm from './CustomerServicesSection/ContactUsForm/ContactUsForm';

function CustomerServices() {
    return (
        <>
            <CustomerServicesBanner />
            {/* <CustomerServicesSection /> */}
            <ContactUsForm/>
        </>
    );
}

export default CustomerServices;